import React, { useEffect, useState } from "react";
import {
  fetchDeliverySettings,
  saveDeliverySetting,
  editDeliverySetting,
} from "../../../../services/Settings/ServicesandTaxSettingsAndSessios/ServicesAndTaxApi";
import {
  Box,
  Typography,
  CircularProgress,
  Paper,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  TextField,
  Button,
  Switch,
  FormControlLabel,
} from "@mui/material";


const Deliveryservice = () => {
  const [settings, setSettings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [price, setPrice] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [saving, setSaving] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [editRow, setEditRow] = useState(null); // id of row being edited
  const [editValues, setEditValues] = useState({}); // { id, title, price, is_active }
  const [editSaving, setEditSaving] = useState(false);

  const loadSettings = () => {
    setLoading(true);
    fetchDeliverySettings()
      .then((data) => setSettings(Array.isArray(data) ? data : []))
      .catch(() => setSettings([]))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    loadSettings();
  }, []);

  const handleSave = async () => {
    setSaving(true);
    setSuccessMsg("");
    try {
      await saveDeliverySetting({
        title,
        price: Number(price),
        is_active: isActive,
      });
      setSuccessMsg("✅ تم إضافة شريحة التوصيل بنجاح!");
      setTitle("");
      setPrice("");
      setIsActive(true);
      loadSettings();
    } catch (err) {
      setSuccessMsg("❌ فشل في إضافة شريحة التوصيل.");
    } finally {
      setSaving(false);
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  const handleEditClick = (item) => {
    setEditRow(item.id);
    setEditValues({
      id: item.id,
      title: item.title,
      price: item.price,
      is_active: !!item.is_active,
    });
  };

  const handleEditChange = (field, value) => {
    setEditValues((prev) => ({
      ...prev,
      [field]: field === "price" ? value.replace(/[^0-9.]/g, "") : value,
    }));
  };

  const handleEditSwitch = (field, checked) => {
    setEditValues((prev) => ({
      ...prev,
      [field]: checked,
    }));
  };

  const handleEditSave = async () => {
    setEditSaving(true);
    setSuccessMsg("");
    try {
      await editDeliverySetting(editValues.id, {
        title: editValues.title,
        price: Number(editValues.price),
        is_active: editValues.is_active,
      });
      setSuccessMsg("✅ تم تعديل الشريحة بنجاح!");
      setEditRow(null);
      setEditValues({});
      loadSettings();
    } catch (err) {
      setSuccessMsg("❌ فشل في تعديل الشريحة.");
    } finally {
      setEditSaving(false);
      setTimeout(() => setSuccessMsg(""), 3000);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", my: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  // Always show the add form. If there are no settings, we'll show
  // an informative row inside the table instead of returning early.

  return (
    <Paper sx={{ p: 3, mt: 2 }}>
      <Typography variant="h6" gutterBottom>
        شرائح التوصيل
      </Typography>
      <Box sx={{ mb: 3 }}>
        <TextField
          label="عنوان الشريحة"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          sx={{ mr: 2, mb: 1 }}
        />
        <TextField
          label="السعر"
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          sx={{ mr: 2, mb: 1 }}
        />
        <FormControlLabel
          control={
            <Switch
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
              color="primary"
            />
          }
          label={isActive ? "مفعل" : "غير مفعل"}
          sx={{ mb: 1 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={handleSave}
          disabled={saving || !title || !price}
          sx={{ mb: 1 }}
        >
          {saving ? "جاري الحفظ..." : "إضافة شريحة"}
        </Button>
        {successMsg && (
          <Typography
            sx={{ mt: 1, color: successMsg.startsWith("✅") ? "green" : "red" }}
          >
            {successMsg}
          </Typography>
        )}
      </Box>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>العنوان</TableCell>
              <TableCell>السعر</TableCell>
              <TableCell>الحالة</TableCell>
              <TableCell>تعديل</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {settings.length === 0 ? (
              <TableRow>
                <TableCell colSpan={4} align="center">
                  لا توجد شرائح توصيل متاحة.
                </TableCell>
              </TableRow>
            ) : (
              settings.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>
                    {editRow === item.id ? (
                      <TextField
                        value={editValues.title}
                        onChange={(e) =>
                          handleEditChange("title", e.target.value)
                        }
                        size="small"
                      />
                    ) : (
                      item.title
                    )}
                  </TableCell>
                  <TableCell>
                    {editRow === item.id ? (
                      <TextField
                        value={editValues.price}
                        onChange={(e) =>
                          handleEditChange("price", e.target.value)
                        }
                        size="small"
                        type="number"
                      />
                    ) : (
                      `${item.price} جنية`
                    )}
                  </TableCell>
                  <TableCell>
                    {editRow === item.id ? (
                      <FormControlLabel
                        control={
                          <Switch
                            checked={!!editValues.is_active}
                            onChange={(e) =>
                              handleEditSwitch("is_active", e.target.checked)
                            }
                            color="primary"
                          />
                        }
                        label={editValues.is_active ? "مفعل" : "غير مفعل"}
                      />
                    ) : item.is_active ? (
                      "مفعل"
                    ) : (
                      "غير مفعل"
                    )}
                  </TableCell>
                  <TableCell>
                    {editRow === item.id ? (
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={handleEditSave}
                        disabled={
                          editSaving || !editValues.title || !editValues.price
                        }
                        sx={{ mr: 1 }}
                      >
                        {editSaving ? "جاري الحفظ..." : "حفظ"}
                      </Button>
                    ) : (
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => handleEditClick(item)}
                      >
                        تعديل
                      </Button>
                    )}
                    {editRow === item.id && (
                      <Button
                        variant="text"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          setEditRow(null);
                          setEditValues({});
                        }}
                      >
                        إلغاء
                      </Button>
                    )}
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default Deliveryservice;
